module.exports = __webpack_public_path__ + "static/img/8.87ea2b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/sp/8.png
// module id = AF4o
// module chunks = 0